import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { html } from 'lit';
import { PartnerActiveState } from '../../api/subscribePartnerByFilter.js';

@Entity()
export class PartnerActiveAspect extends AbstractAspect {
  static override _class = 'PartnerActiveAspect';

  constructor(doc: PartialEntityData<PartnerActiveAspect>) {
    const newDoc = {
      customID: 'partnerActiveState',
      ...doc,
    };
    super(newDoc);
  }

  @Field(() => String) value: Maybe<string>;
}

export const PartnerActiveAspectSchema: AspectConfig<PartnerActiveAspect> = {
  aspectConstructor: PartnerActiveAspect,
  renderEditor: ({ aspectValue }) => html`
    <cr-dropdown-search-selection
      clearable
      placeholder="Status"
      placeholder-mode="hide"
      .selectables=${Object.values(PartnerActiveState)}
      .value=${aspectValue.value}
      @value-picked=${(e: ValueEvent<Maybe<string>>) => {
        aspectValue.value = e.detail.value;
      }}
    ></cr-dropdown-search-selection>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.value ? html` ${aspectValue.value} ` : null),
};
